export default __webpack_public_path__ + "c85497dca936eade5048644b21433d88.png";